import { socialEmbedUrl } from "@ui/utils";
import type { PlaceDetailEmbed } from "./types";

type Props = {
	embed: PlaceDetailEmbed;
	name: string;
	emptyLabel: string;
};

export function DetailEmbedMedia({ embed, name, emptyLabel }: Props) {
	if (embed.videoUrl) {
		return (
			<video
				autoPlay
				loop
				muted
				playsInline
				preload="auto"
				aria-label={name}
				className="absolute inset-0 h-full w-full object-cover"
			>
				<source src={embed.videoUrl} />
			</video>
		);
	}

	// Temporary stand-in until CF-7 lands a hosted video file: embed the real
	// post so there is at least something to watch. Revert to the poster-only
	// branch once videoUrl is populated for real.
	const iframeSrc = embed.platform
		? socialEmbedUrl(embed.platform, embed.sourceUrl)
		: null;
	if (iframeSrc) {
		return (
			<iframe
				src={iframeSrc}
				title={name}
				className="absolute inset-0 h-full w-full border-0 bg-white"
				allow="autoplay; encrypted-media; picture-in-picture"
				allowFullScreen
			/>
		);
	}

	if (embed.poster) {
		return (
			<img
				src={embed.poster}
				alt={name}
				className="absolute inset-0 h-full w-full object-cover"
			/>
		);
	}

	return (
		<div className="absolute inset-0 grid place-items-center">
			<span className="text-[12px] font-medium text-[rgb(255_255_255_/_0.6)]">
				{emptyLabel}
			</span>
		</div>
	);
}
